// removed by extract-text-webpack-plugin
module.exports = {"quantitySelector":"_1-GMM","flexLayout":"_1qu-9","quantityButtons":"_1j6eq","quantitySelect":"_3uTT0","lessButton":"_2HSJM","moreButton":"_2yLVh","quantityInput":"_1eq8Q","buyButton":"_3EU3A","shake":"hPJVW","invalid":"_3a_qo","soldOut":"NwVQl","unavailable":"_24AEa"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/QuantitySelector/index.sass
// module id = 1501
// module chunks = 1